import EventForm from "../components/event/eventform/EventForm";

const Home = () => {
    return (
        <EventForm />
    );
}

export default Home;